import AtomH1 from "Components/Atoms/H1";
import AtomSubtitle2 from "Components/Atoms/Subtitle2";
import AtomCircle from "Components/Atoms/Circle";
import Share from "./Share";

import styled from "styled-components";

import * as Types from "Types";

export interface NowContentsHeaderProps extends Types.Default {
   title: string;
   date: string;
}

const Wrap = styled.div<Types.Default>`
   display: flex;
   flex-direction: column;
   align-items: center;
   ${({ css }) => css}
`;

const ChildDate = styled(AtomSubtitle2)`
   line-height: 22px;
`;
const ChildTitle = styled(AtomH1)`
   line-height: 45px;
   margin-top: 10px;
   text-align: center;
`;
const ChildSubtitle = styled.h2`
   margin-top: 29px;
   font-weight: 400;
   letter-spacing: -0.02em;
   color: #7c7c7c;
   font-size: 17px;
   line-height: 25px;
`;
const ChildCircle = styled(AtomCircle)`
   margin-top: 30px;
`;

export default function NowList(props: any) {
   return (
      <Wrap css={props.css} className={props.className}>
         <ChildDate>{props.date}</ChildDate>
         <ChildTitle>
            {props.title} <Share />
         </ChildTitle>
         <ChildSubtitle>{props.subtitle}</ChildSubtitle>
         <ChildCircle></ChildCircle>
      </Wrap>
   );
}
